var StepNames;
(function(StepNames) {
    StepNames["Login"] = 'login';
    StepNames["Shipping"] = 'shipping';
    StepNames["Overview"] = 'overview';
    StepNames["Payment"] = 'payment';
})(StepNames || (StepNames = {}));

export { StepNames };
//# sourceMappingURL=shared.js.map
